/* hai-busqueda.js — sinónimos de búsqueda por código y atajo a la colección
   por objetivo. Los datos viven en snippets/hai-sinonimos.liquid (JSON que
   imprime theme.liquid); aquí solo la lógica.

   Principio de siempre: alimentar el control del tema, no reemplazarlo. El
   predictivo sigue siendo el <predictive-search> de Avante: se envuelven dos
   métodos de su prototipo (la consulta que manda y el pintado de resultados).
   Al enviar el formulario, si lo escrito es una palabra de necesidad, se va a
   la colección por objetivo si el grupo tiene una; si no, a /search con la
   consulta expandida y la palabra original en `hai` para mostrarla.

   Falla en silencio: sin tabla, o con una palabra que no está en ella, la
   consulta viaja intacta y la búsqueda se comporta como siempre. */
(() => {
  if (window.__haiBusqueda) return;
  window.__haiBusqueda = true;

  const nodo = document.querySelector('.hai-sinonimos-datos');
  let grupos = [];
  try { grupos = JSON.parse(nodo ? nodo.textContent : '[]'); } catch (e) { grupos = []; }
  if (!Array.isArray(grupos)) grupos = [];

  // Sin tildes, sin mayúsculas, sin espacios repetidos: "Concentración" y
  // "concentracion" son la misma palabra.
  const normalizar = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  grupos.forEach((g) => { g.claves = (g.disparadores || []).map(normalizar).filter(Boolean); });

  // Exacto desde 3 letras, por prefijo desde 5 ("cansa" → Energía). El 5 no
  // es capricho: con 4, "vita" disparaba "vitalidad" y estrechaba a Energía
  // lo que alguien iba a escribir como "vitamina c".
  const MIN_EXACTO = 3;
  const MIN_PREFIJO = 5;
  const porClave = (t, conPrefijo) => {
    if (t.length < MIN_EXACTO) return null;
    const exacto = grupos.find((g) => g.claves.includes(t));
    if (exacto) return exacto;
    if (!conPrefijo || t.length < MIN_PREFIJO) return null;
    return grupos.find((g) => g.claves.some((k) => k.startsWith(t))) || null;
  };

  // Grupo para lo escrito: primero la frase entera; si no, palabra por
  // palabra ("para dormir", "quiero dormir"), con prefijo solo en la última.
  // Los ingredientes no están en disparadores, así que "magnesio" pasa intacto.
  const grupoDe = (termino) => {
    const t = normalizar(termino);
    const entero = porClave(t, true);
    if (entero) return entero;
    const palabras = t.split(' ');
    if (palabras.length < 2 || palabras.length > 4) return null;
    for (let i = 0; i < palabras.length; i += 1) {
      const g = porClave(palabras[i], i === palabras.length - 1);
      if (g) return g;
    }
    return null;
  };

  // Lo que viaja a Shopify es SOLO la expansión, unida con OR y con CADA
  // término entre comillas. Medido el 09-sep-2026 en suggest.json y /search:
  // una cadena de palabras sueltas no es una unión limpia (Shopify la va
  // achicando: "tongkat OR tribulus OR maca OR zinc OR shilajit" devolvía 0
  // con cada palabra encontrando sola); con los términos entre comillas es
  // la unión exacta (esa misma cadena: 6 en el predictivo, 9 en la página).
  // Por eso la tabla nombra las cosas como aparecen en los TÍTULOS (MagneZen
  // además de magnesio, Iron C además de hierro). La palabra de necesidad no
  // viaja: no suma (Shopify no la encuentra, por eso estamos aquí) y a veces
  // resta ("… OR dormir" perdió Teanina).
  const citar = (x) => '"' + x.replace(/"/g, '') + '"';
  const expandir = (g) => [...new Set((g.expansion || []).map((x) => String(x).trim()).filter(Boolean))].map(citar).join(' OR ');
  const consultaPara = (termino) => {
    const g = grupoDe(termino);
    const q = g ? expandir(g) : '';
    return q || termino;
  };

  /* ---- 1. Predictivo: consulta expandida + fila "Ver <colección>" ---- */
  const atajo = (ps) => {
    const cont = ps.predictiveSearchResults;
    if (!cont) return;
    const previo = cont.querySelector('.hai-atajo');
    if (previo) previo.remove();
    const g = grupoDe(ps.getQuery());
    if (!g || !g.url || !g.etiqueta) return;
    const a = document.createElement('a');
    a.className = 'hai-atajo';
    a.href = g.url;
    a.innerHTML = '<span class="hai-atajo__eyebrow">Colección</span><span class="hai-atajo__label"></span>';
    a.querySelector('.hai-atajo__label').textContent = 'Ver ' + g.etiqueta;
    cont.prepend(a);
  };

  // Red de seguridad: si la consulta expandida vuelve sin productos, se
  // repite con lo escrito tal cual. Nunca peor que hoy. (Los OR de Shopify
  // no son una unión limpia: "tongkat OR tribulus OR maca OR zinc OR
  // shilajit" devolvía 0 con cada palabra encontrando sola, 09-sep-2026.)
  const sinProductos = (ps) => !ps.predictiveSearchResults.querySelector('#content-predictive-search-products [role="option"]');
  // Sin pestañas en el modal (09-sep-2026, Andrés): las colecciones que
  // devuelve la búsqueda pasan a filas "Ver <colección>" arriba de la lista
  // (solo si no hay ya un grupo de sinónimos con colección), y el botón
  // "Ver todos los resultados" del tema, que flotaba al centro del modal,
  // baja al final de la lista de productos (el CSS lo vuelve una fila).
  const ordenarResultados = (ps) => {
    const cont = ps.predictiveSearchResults;
    if (!cont) return;
    const g = grupoDe(ps.getQuery());
    if (!g || !g.url) {
      const colecciones = [...cont.querySelectorAll('#content-predictive-search-collections a.card-collection')].slice(0, 2).reverse();
      colecciones.forEach((enlace) => {
        const titulo = (enlace.querySelector('.card__title') || enlace).textContent.replace(/\s+/g, ' ').trim();
        if (!titulo) return;
        const fila = document.createElement('a');
        fila.className = 'hai-atajo hai-atajo--coleccion';
        fila.href = enlace.href;
        fila.innerHTML = '<span class="hai-atajo__eyebrow">Colección</span><span class="hai-atajo__label"></span>';
        fila.querySelector('.hai-atajo__label').textContent = 'Ver ' + titulo;
        cont.prepend(fila);
      });
    }
    const boton = cont.querySelector('.predictive-search__button');
    const panel = cont.querySelector('#content-predictive-search-products');
    if (boton && panel && !boton.classList.contains('hai-ver-todos')) {
      boton.classList.add('hai-ver-todos');
      panel.appendChild(boton);
    }
    // <product-card-image> del tema se inicializa "de primera intención"
    // (pointerenter/pointerdown, una vez) y ese cambio de contenido en el
    // primer toque hacía que iOS no entregara el clic. Se dispara ya, al
    // pintar los resultados: el primer toque real ya no cambia nada.
    cont.querySelectorAll('product-card-image').forEach((el) => {
      try { el.dispatchEvent(new Event('pointerdown')); } catch (e) { /* sin soporte */ }
    });
  };

  const envolver = (Clase) => {
    const proto = Clase && Clase.prototype;
    if (!proto || !proto.getSearchResults || !proto.renderSearchResults || proto.__haiEnvuelto) return;
    proto.__haiEnvuelto = true;
    const buscar = proto.getSearchResults;
    proto.getSearchResults = function (termino) {
      const q = consultaPara(termino);
      this.__haiOriginal = q !== termino ? termino : '';
      return buscar.call(this, q);
    };
    const pintar = proto.renderSearchResults;
    proto.renderSearchResults = function (markup) {
      pintar.call(this, markup);
      const original = this.__haiOriginal;
      this.__haiOriginal = '';
      if (original && sinProductos(this)) { buscar.call(this, original); return; }
      atajo(this);
      ordenarResultados(this);
    };
  };

  /* ---- 1b. El "Buscar" del menú hamburguesa abre el buscador de verdad ---- */
  // El drawer trae su propio campo de búsqueda (bloque "search" en modo
  // campo) con una copia del modal adentro; al escribir ahí el tema abría
  // ESA copia dentro del drawer, que se esconde: pantalla bloqueada y nada a
  // la vista (Andrés, 09-sep: "se ve todo desordenado"). El campo queda
  // como disparador: cierra el drawer y abre el buscador del header.
  const SEL_CAMPO_DRAWER = '#menu-drawer .search-field__text, .menu-drawer .search-field__text';
  let ultimoAbrir = 0;
  let inputPrincipal = null;
  // Todo SÍNCRONO dentro del gesto: iOS solo abre el teclado si focus()
  // corre dentro del toque (Andrés, 09-sep: "tengo que darle 2 veces"). Por
  // eso no hay setTimeout: cerrar el drawer y abrir el buscador van en el
  // mismo tick, y el input se enfoca ahí mismo (y de nuevo en touchend).
  const abrirBuscadorPrincipal = () => {
    const ahora = Date.now();
    if (ahora - ultimoAbrir < 800) return;
    ultimoAbrir = ahora;
    const cerrar = document.querySelector('#menu-drawer .menu-drawer__close button, .menu-drawer .menu-drawer__close button, .menu-drawer__close button, .menu-drawer__close');
    if (cerrar) cerrar.click();
    const resumen = [...document.querySelectorAll('search-modal summary')].find((s) => !s.closest('#menu-drawer, .menu-drawer') && s.offsetParent !== null);
    if (!resumen) return;
    resumen.click();
    const raiz = resumen.closest('search-modal');
    inputPrincipal = raiz ? raiz.querySelector('.search-modal .search__input') : null;
  };
  const enfocarPrincipal = () => {
    if (!inputPrincipal) return;
    try { inputPrincipal.focus({ preventScroll: true }); } catch (e) { inputPrincipal.focus(); }
  };
  const campoDrawerDe = (event) => (event.target && event.target.closest ? event.target.closest(SEL_CAMPO_DRAWER) : null);
  const redirigir = (event, campo) => {
    if (event.cancelable) event.preventDefault();
    if (document.activeElement === campo) campo.blur();
    abrirBuscadorPrincipal();
    enfocarPrincipal();
  };
  // 11-sep-2026 (Andrés: "se activa involuntariamente al desplazar"): la
  // primera versión actuaba en touchstart, apenas el dedo se apoyaba, y el
  // campo mide 343 × 48 px en medio del menú: un scroll que arrancaba ahí
  // abría el buscador. Ahora en táctil se decide al SOLTAR, con la misma
  // disciplina que las tarjetas (≤ 16 px y ≤ 900 ms = toque; si no, scroll y
  // no pasa nada). touchend sigue siendo gesto de usuario para iOS, así que
  // el teclado del buscador sale igual. El mouse decide en pointerdown (no
  // desplaza) y focusin queda de red para el teclado físico o una pulsación
  // larga que llegue a enfocar el campo del drawer.
  const TOQUE_DRAWER_MOV = 16;
  const TOQUE_DRAWER_MS = 900;
  let toqueDrawer = null;
  document.addEventListener('touchstart', (event) => {
    const campo = campoDrawerDe(event);
    const t = event.touches && event.touches[0];
    toqueDrawer = campo && t ? { campo, x: t.clientX, y: t.clientY, t: Date.now() } : null;
  }, { capture: true, passive: true });
  document.addEventListener('touchend', (event) => {
    const inicio = toqueDrawer;
    toqueDrawer = null;
    if (!inicio) return;
    const t = event.changedTouches && event.changedTouches[0];
    if (t && (Math.abs(t.clientX - inicio.x) > TOQUE_DRAWER_MOV || Math.abs(t.clientY - inicio.y) > TOQUE_DRAWER_MOV)) return;
    if (Date.now() - inicio.t > TOQUE_DRAWER_MS) return;
    redirigir(event, inicio.campo);
  }, { capture: true, passive: false });
  document.addEventListener('touchcancel', () => { toqueDrawer = null; }, { capture: true, passive: true });
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') return;
    const campo = campoDrawerDe(event);
    if (campo) redirigir(event, campo);
  }, true);
  document.addEventListener('focusin', (event) => {
    const campo = campoDrawerDe(event);
    if (campo) redirigir(event, campo);
  }, true);
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(() => envolver(customElements.get('predictive-search')));
  }

  /* ---- 2. Enviar: colección por objetivo, o /search expandido ---- */
  const CLAVE = 'hai-busqueda';
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"], form.search-modal__form')) return;
    const input = form.querySelector('input[name="q"]');
    const termino = input ? input.value.trim() : '';
    const g = termino ? grupoDe(termino) : null;
    if (!g) return;
    // Con una opción del predictivo seleccionada con las flechas, el tema
    // navega a ella; no nos metemos.
    if (form.querySelector('[aria-selected="true"][role="option"] a, [aria-selected="true"][role="option"] button')) return;
    event.preventDefault();
    if (g.url) { window.location.assign(g.url); return; }
    const expandida = expandir(g);
    if (!expandida) return;
    try { sessionStorage.setItem(CLAVE, JSON.stringify({ q: expandida, t: termino })); } catch (e) { /* sin sesión */ }
    const datos = new FormData(form);
    datos.set('q', expandida);
    datos.set('hai', termino);
    window.location.assign((form.getAttribute('action') || '/search') + '?' + new URLSearchParams(datos).toString());
  }, true);

  /* ---- 3. Página de resultados: mostrar la palabra, no la expansión ---- */
  // `hai` viene en la URL al llegar; al filtrar o paginar el tema la pierde,
  // por eso también queda en sessionStorage atada a la consulta expandida.
  const restaurar = () => {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    const params = new URLSearchParams(window.location.search);
    const q = (params.get('q') || '').trim();
    let original = (params.get('hai') || '').trim();
    if (!original) {
      try {
        const m = JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
        if (m && m.q === q) original = m.t;
      } catch (e) { original = ''; }
    }
    if (!q || !original || original === q) return;
    // Misma red de seguridad que en el predictivo: expansión sin resultados
    // → la búsqueda de siempre con la palabra original (sin `hai`, no cicla).
    if (params.has('hai') && document.querySelector('.collection__no-products')) {
      window.location.replace('/search?q=' + encodeURIComponent(original) + '&options%5Bprefix%5D=last');
      return;
    }
    document.querySelectorAll('input[name="q"]').forEach((i) => { if (i.value.trim() === q) i.value = original; });
    const recorrer = (el) => {
      el.childNodes.forEach((n) => {
        if (n.nodeType === 3) { if (n.nodeValue.includes(q)) n.nodeValue = n.nodeValue.split(q).join(original); }
        else if (n.nodeType === 1 && n.tagName !== 'SCRIPT' && n.tagName !== 'STYLE') recorrer(n);
      });
    };
    document.querySelectorAll('.template-search__header, .collection__no-products, .hai-aili-ayuda').forEach(recorrer);
    const codificar = (s) => encodeURIComponent(s).replace(/%20/g, '+');
    document.querySelectorAll('a[href*="wa.me"]').forEach((a) => {
      const enc = codificar(q);
      if (a.href.includes(enc)) a.href = a.href.split(enc).join(codificar(original));
    });
    if (document.title.includes(q)) document.title = document.title.split(q).join(original);
  };
  restaurar();
})();
